<template>
    <OperationCard
        :operation="operation"
        @toOperation="toOperation"
        :mainAmount="operation.amount"
        :mainAmountAbbr="operation.currency.abbr"
        :convertAmount="operation.amountUsd"
        :convertAmountText="getOperationTypeText()"
    >
        <template #icon>
            <i class="icon" :class="iconPayment"></i>
        </template>
    </OperationCard>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { computed } from "vue";
import WithdrawalOperation from "@models/operations/WithdrawalOperation";
import ModelAccount from "@models/v2/account/ModelAccount";
import OperationCard from "@components/atomic/operations/cards/atomic/OperationCard.vue";

const {t} = useI18n({useScope: 'global'});

interface Emits {
    (e: 'toOperation'): void,
}

interface Props {
    operation: WithdrawalOperation;
    account: ModelAccount;
}

const emits = defineEmits<Emits>();

const props = defineProps<Props>();

const slugs = ["olimp", "olimp-casino"];

const isIncludedSlugs = computed(() => {
    return slugs.includes(String(props.account.project.slug));
});

const iconPayment = computed(() => {
    if (isIncludedSlugs.value) {
        if (props.operation.operationType == 'purchase') {
            return 'logo-round-olimp-com-svg';
        } else {
            return 'logo-round-minus-svg';
        }
    } else {
        if (props.operation.operationType == 'purchase') {
            return 'logo-round-plus-svg';
        } else {
            return 'logo-round-minus-svg';
        }
    }
});

const toOperation = async () => {
    emits('toOperation');
}

const getOperationTypeText = () => {
    switch (props.operation.operationType) {
        case "purchase":
            if (isIncludedSlugs.value) {
                return t('payment.pay');
            }
            return t('payment.purchase');
        case "sale":
            return t('payment.sale');
    }
    return "";
}
</script>
